import "./Home.module.css";
import NavegacionDeLujo from "@/reusable_sections/Header";
import FreshlyRoastedPerfection from "./sections/FreshlyRoastedPerfection";
import TheTrendForecast from "./sections/TheTrendForecast";
import GlobalImpactInNumbers from "./sections/GlobalImpactInNumbers";
import FeaturedEnvironments from "./sections/FeaturedEnvironments";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <NavegacionDeLujo />
      <FreshlyRoastedPerfection />
      <TheTrendForecast />
      <GlobalImpactInNumbers />
      <FeaturedEnvironments />
      <Footer />
    </div>;
}